import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  // Función para generar un array de números de página a mostrar
  const getPageNumbers = () => {
    const pageNumbers = [];
    
    // Si hay menos de 7 páginas, mostrar todas
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Si hay más de 7 páginas, implementamos una lógica de "..."
      if (currentPage <= 3) {
        // Si estamos en las primeras páginas
        for (let i = 1; i <= 5; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        // Si estamos en las últimas páginas
        pageNumbers.push(1);
        pageNumbers.push('...');
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        // Si estamos en páginas intermedias
        pageNumbers.push(1);
        pageNumbers.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      }
    }
    
    return pageNumbers;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="flex items-center justify-center space-x-2">
      {/* Botón anterior */}
      <button
        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`px-3 py-1 rounded-md ${
          currentPage === 1
            ? 'bg-gray-700 text-gray-500 cursor-not-allowed'
            : 'bg-blue-600 text-white hover:bg-blue-700'
        }`}
      >
        &laquo;
      </button>
      
      {/* Números de página */}
      {pageNumbers.map((number, index) => (
        <button
          key={index}
          onClick={() => number !== '...' && onPageChange(number)}
          disabled={number === '...'}
          className={`px-3 py-1 rounded-md ${
            number === currentPage
              ? 'bg-blue-600 text-white'
              : number === '...'
              ? 'bg-gray-700 text-gray-300 cursor-default'
              : 'bg-gray-700 text-white hover:bg-gray-600'
          }`}
        >
          {number}
        </button>
      ))}
      
      {/* Botón siguiente */}
      <button
        onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`px-3 py-1 rounded-md ${
          currentPage === totalPages
            ? 'bg-gray-700 text-gray-500 cursor-not-allowed'
            : 'bg-blue-600 text-white hover:bg-blue-700'
        }`}
      >
        &raquo;
      </button>
    </div>
  );
};

export default Pagination;
